import {getStationCode} from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/Util";
import {CAPABILITY} from "../../util/Constants";
import {chainWalk} from "../../util/Util";

const metricProcessName = "SCC_INDUCT";

/**
 * API call for fetching Induct Overview
 * @param filter
 * @param capability
 * @param dispatcher
 */
export function fetchInductOverview(filter, capability, dispatcher) {
    let filterMap = {
        'Cycle': filter.Cycle
    }
    const request = {
        nodeId: getStationCode(),
        groupBy: 'Node',
        filters: filterMap,
        metricList: ["PENDING_DEPART_FROM_UPSTREAM", "PENDING_DEPART_FROM_UPSTREAM_UNPLANNED", "IN_TRANSIT_FROM_UPSTREAM",
            "IN_TRANSIT_FROM_UPSTREAM_UNPLANNED", "PENDING_INDUCT", "PENDING_INDUCT_UNPLANNED", "PENDING_RE_INDUCT",
            "PENDING_RE_INDUCT_UNPLANNED", "INDUCTED_AT_STATION", "PLANNED_CURRENT_CYCLE_INDUCTED",
            "UNPLANNED_CURRENT_CYCLE_INDUCTED"]
    }

    if (CAPABILITY.AR_NEXT_GEN === capability) {
        request.metricList.push("PROBLEM_SOLVE")
    } else {
        request.metricList.push("SIDELINE")
    }

    getPackageMetrics(filter, dispatcher, request);
    fetchStowNumber(filter, dispatcher);
    fetchContainerPlannedNumber(filter, dispatcher);
}

function getReceiveDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getPackageMetric",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getPackageMetrics(filter, dispatcher, request) {
    const args = getReceiveDataAPIGatewayRequest(request);
    const startTime = Date.now();
    const isSingleCycleSelected = filter.Cycle.length === 1 && !filter.Cycle.includes("NONE");
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageMetric", true);
            const output = result.data.groupedPackageMetrics
            const stationCode = getStationCode()
            dispatcher({type: "RECEIVE_DATA", data: {
                    pending_depart_from_upstream: (output.PENDING_DEPART_FROM_UPSTREAM)[stationCode],
                    pending_depart_from_upstream_unplanned: (output.PENDING_DEPART_FROM_UPSTREAM_UNPLANNED)[stationCode],
                    in_transit_from_upstream: (output.IN_TRANSIT_FROM_UPSTREAM)[stationCode],
                    in_transit_from_upstream_unplanned: (output.IN_TRANSIT_FROM_UPSTREAM_UNPLANNED)[stationCode],
                    pending_induct: (output.PENDING_INDUCT)[stationCode],
                    pending_induct_unplanned: (output.PENDING_INDUCT_UNPLANNED)[stationCode],
                    pending_re_induct: (output.PENDING_RE_INDUCT)[stationCode],
                    pending_re_induct_unplanned: (output.PENDING_RE_INDUCT_UNPLANNED)[stationCode],
                    inducted: (output.INDUCTED_AT_STATION)[stationCode],
                    planned_inducted: isSingleCycleSelected? (output.PLANNED_CURRENT_CYCLE_INDUCTED)[stationCode]: "-",
                    unplanned_inducted: isSingleCycleSelected? (output.UNPLANNED_CURRENT_CYCLE_INDUCTED)[stationCode]: "-",
                    sidelined: chainWalk(() => (output.SIDELINE)[stationCode]),
                    problem_solve: chainWalk(() => (output.PROBLEM_SOLVE)[stationCode]),
                    total_inducted_actual: isSingleCycleSelected? (output.PLANNED_CURRENT_CYCLE_INDUCTED)[stationCode] + (output.UNPLANNED_CURRENT_CYCLE_INDUCTED)[stationCode]: "-"
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageMetric", false);
        }
    });
}


/**
 * API call for fetching stow number
 */

function fetchStowNumber(filter, dispatcher)  {
    let requestFilter;
    if (filter && filter.Cycle.length > 0) {
        requestFilter = {
            NODE: [getStationCode()],
            CYCLE: filter.Cycle
        }
    } else {
        requestFilter = {
            NODE: [getStationCode()]
        }
    }
    const request = {
        filters: requestFilter,
        groupBy: 'NONE',
        metrics: ["CURRENT_STOWED_COUNT"]
    }
    getStowMetrics(dispatcher, request);
}

function getStowAPIGatewayRequest(request) {
    return {
        resourcePath: "svs/packages/metrics",
        httpMethod: "post",
        processName: "stow",
        requestBody: request
    }
}

async function getStowMetrics(dispatcher, request) {
    const args = getStowAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getStowData", true);
            const output = result.data.groupedPackageMetrics
            dispatcher({type: "RECEIVE_STOW_DATA", data: {
                stowed: (output["Total"]).currentStowedCount,
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getStowData", false);
        }
    });
}


/**
 * API call for fetching location metrics
 * @param filter
 * @param dispatcher
 */
export function fetchLocationMetrics(filter, dispatcher) {
    const request = {
        nodeId: getStationCode()
    }
    getLocationMetrics(dispatcher, request)
}

function fetchLocationMetricsAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getLocationMetric",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getLocationMetrics(dispatcher, request) {
    const args = fetchLocationMetricsAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getLocationData", true);
            let output = result.data.locationInsightList
            let locationMetrics = output.filter(location => location.volumeInducted > 0)
            const total = getAggregateMetrics(locationMetrics);
            if (total != null) {
                locationMetrics.push(total)
            }
            dispatcher({type: "INDUCT_AREA_INSIGHT", data: {
                 inductAreaData: locationMetrics
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getLocationData", false);
        }
    });
}

function getAggregateMetrics(locationMetrics) {
    if (locationMetrics.length === 0) {
        return null;
    }
    const aggregateMetric = {
        locationName: 'Total',
        operatorCount: 0,
        inductRate: 0,
        volumeInducted: 0
    }
    locationMetrics.forEach(metrics => {
        aggregateMetric.operatorCount = aggregateMetric.operatorCount + metrics.operatorCount
        aggregateMetric.inductRate = aggregateMetric.inductRate + metrics.inductRate
        aggregateMetric.volumeInducted = aggregateMetric.volumeInducted + metrics.volumeInducted
    })
    return aggregateMetric;
}

/**
 * API to fetch LineHauls List and associated container details
 * @param filter
 * @param dispatcher
 */
export function fetchLineHaulsContainerDetails(filter, dispatcher) {
    getArrivedLineHaulList(filter, dispatcher);
}

function getLineHaulListAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getNodeLineHaulList",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getArrivedLineHaulList(filter, dispatcher) {
    const request = {
        nodeId: getStationCode()
    }
    const args = getLineHaulListAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getArrivedLineHaul", true);
            const lineHaulList = [];
            const output = result.data.lineHauls;
            output.forEach(lineHaul => {
                if (lineHaul.lineHaulStatus === "ARRIVED" && lineHaul.volume > 0) {
                    lineHaulList.push(lineHaul.lineHaulId);
                }
            });
            fetchLineHaulsContainerList(filter, dispatcher, lineHaulList)
            dispatcher({type: "LINE_HAUL_DATE_RECEIVED", data: {
                lineHaulList: lineHaulList
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getArrivedLineHaul", false);
        }
    });
}

export function fetchLineHaulsContainerList(filter, dispatcher, lineHaulList) {
    if (lineHaulList && lineHaulList.length > 0) {
        let filterMap = {
            "Cycle": filter.Cycle,
            "EAD": filter.EAD,
            "OtherAttributes": filter.OtherAttributes,
            "Cluster": filter.Cluster,
            "PackageSize": filter.PackageSize
        };
        const request = {
            nodeId: getStationCode(),
            lineHaulId: lineHaulList,
            filters: filterMap
        };
        getContainerDetail(dispatcher, request);
    }
}

function getContainerDetailAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getLineHaulContainerDetail",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getContainerDetail(dispatcher, request) {
    const args = getContainerDetailAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getLineHaulContainer", true);
            let output = result.data.lineHaulsContainerDetail;
            dispatcher({type: "LINE_HAULS_CONTAINER_DATA_RECEIVED", data: {
                containerDetail: (output) ? output : {}
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getLineHaulContainer", false);
        }
    });
}

function fetchContainerPlannedNumber(filter, dispatcher) {
    let requestFilter;
    const isSingleCycleSelected = filter.Cycle.length === 1 && !filter.Cycle.includes("NONE");

    if (isSingleCycleSelected) {
        requestFilter = {
            NODE: [getStationCode()],
            CYCLE_ID: filter.Filters.Cycle.filter(cycleDetail => filter.Cycle.includes(cycleDetail.cycleId))
                .map(cycleDetail => cycleDetail.casCycleId)
        }
        const request = {
            filters: requestFilter,
            groupBy: 'NODE',
            metrics: ["PLANNED_COUNT"]
        }

        getContainerPlannedMetrics(dispatcher, request);
    } else {
        dispatcher({
            type: "RECEIVE_PLANNED_DATA", data: {
                planned_cycle_volume: '-'
            }
        });
    }
}


async function getContainerPlannedMetrics(dispatcher, request) {
    const args = getStowAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getContainerPlannedMetric", true);
            const output = result.data.groupedPackageMetrics
            const stationCode = getStationCode()
            dispatcher({type: "RECEIVE_PLANNED_DATA", data: {
                    planned_cycle_volume: (output[stationCode]) ? (output[stationCode]).plannedCount : '-'
                }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getContainerPlannedMetric", true);
        }
    });
}



// WEBPACK FOOTER //
// ./src/components/induct/network/InductNetworkAPI.js